<script setup lang="ts">

import ToolTip from "@/components/UI/tooltip/ToolTip.vue";
import { RiArrowRightSLine, RiInformationLine } from "@remixicon/vue";
import ActivityCard from "@/components/dashboard/ActivityCard.vue";
import CarbonFootprintDoughnut from "@/components/dashboard/CarbonFootprintDoughnut.vue";
import BarChart from "@/components/analysis/BarChart.vue";
import { useCompanyStore } from "@/stores/company";
import { useCompanyFacilities } from "@/stores/facilities";
import { useAnalytic } from "@/stores/analysis";
import { useI18n } from "vue-i18n";
import { onMounted } from "vue";
import { hasSelectedCompany } from "@/utils/companyContext";



const companyStore = useCompanyStore();
const { getCompany } = companyStore;
const facilitiesStore = useCompanyFacilities();
const analytic = useAnalytic();
const { getCompanyFacilities } = facilitiesStore;
const { fetchAnalysis, fetchTimeSeries } = analytic;

const { t } = useI18n();
analytic.$patch({ breakdown: "FACILITY", facilities: [], year: "" });

onMounted(async () => {
  // Don't load company data before a company is selected (super admin flow).
  if (!hasSelectedCompany()) return;
  await getCompany();
  await getCompanyFacilities();
  await fetchAnalysis();
  await fetchTimeSeries()
});

</script>

<template>
  <div class="grid grid-cols-6 gap-4">
    <CarbonFootprintDoughnut
      data-step="1"
      :data-intro="t('dashboard.carbonFootprintToolTip')"
    />
    <div
      class="col-span-2 border border-neautrals-200 rounded-md"
      data-step="2"
      data-intro="In this area you can see a summary of your carbon emissions by year."
    >
      <div class="col-span-2 border border-neautrals-200 rounded-md bg-white">
        <div class="flex p-4 items-center justify-between shadow">
          <span class="flex">
            <span class="mr-2">{{ t("dashboard.carbonStory") }}</span>
            <ToolTip
              placement="bottom"
              :title="$t('dashboard.carbonStory')"
              :content="$t('calculation.tooltip.carbonStory')"
            >
              <RiInformationLine className="w-5 h-5" />
            </ToolTip>
          </span>
          <router-link :to="{ name: 'analysis' }" class="flex">
            <span class="mr-4 underline font-medium">{{
                t("dashboard.goIntoDetail")
              }}</span>
            <RiArrowRightSLine />
          </router-link>
        </div>
        <div class="items-center text-center relative pt-20">
          <span class="absolute z-10 top-6 text-xxs left-20">tCO2e</span>
          <BarChart />
        </div>
      </div>
    </div>
    <div class="col-span-1">
      <ActivityCard
        data-step="4"
        data-intro="Keep track of what's happening in your company here."
      />
    </div>
  </div>
</template>
